type StudentHelperEventAction = "chat" | "incorrect_answer" | "correct_answer"

interface StudentHelperEventDTO {
  action: StudentHelperEventAction
  text: string
}

export class StudentHelperEvent {
  constructor(
    public readonly action: StudentHelperEventAction,
    public readonly text: string,
  ) {}

  static fromDTO({ action, text }: StudentHelperEventDTO): StudentHelperEvent {
    return new StudentHelperEvent(action, text)
  }

  toDTO(): StudentHelperEventDTO {
    return {
      action: this.action,
      text: this.text,
    }
  }
}
